module.exports = __webpack_public_path__ + "static/img/logo-enjoei.0dc2ebd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-enjoei.png
// module id = 3rR3
// module chunks = 1